import { Alert, Button, Card, CardHeader, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import React, { useCallback, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

import { get } from "../utils/BackendClientLegacy";
import { StyledCardContent } from "../utils/StyledComponents";

export const ArchiverLogs = () => {
  const [searchParams] = useSearchParams();
  const isLive = searchParams.get("mode") === "live";

  // logs state
  const [state, setState] = useState({ logs: {}, page: 0 });

  const loadData = useCallback(
    async (page = 0) => {
      const packedLogs =
        isLive && page === 0
          ? await get("archive-candidates/archiving-results")
          : await get(`archive-candidates/logs?page=${page}`);
      const unwrappedLogs = await packedLogs.json();

      function getHour(l) {
        return `${l.processingDate.substring(0, 13)}:00:00`;
      }

      setState((prev) => {
        // flatten previous logs
        const loadedLogs = Object.values(prev.logs).flat();

        // concat old + new
        const allLogs = [...loadedLogs, ...unwrappedLogs];

        // group by hour
        const groupedLogs = allLogs.reduce((acc, log) => {
          const hour = getHour(log);
          if (!acc[hour]) acc[hour] = [];
          acc[hour].push(log);
          return acc;
        }, {});

        return {
          ...prev,
          logs: groupedLogs,
          page: unwrappedLogs.length > 0 ? page : -1,
        };
      });
    },
    [isLive],
  );

  useEffect(() => {
    async function loadInitialData() {
      await loadData();
    }

    loadInitialData().then();
  }, [loadData]);
  const index = Object.keys(state.logs).sort().reverse();
  const sortedLogs = index.map((v) => {
    return { date: v, logs: state.logs[v] };
  });

  function renderHours(logsOfTheHour, index) {
    return (
      <div key={index}>
        <h3>{`${logsOfTheHour.date.substring(0, 10)} ${logsOfTheHour.date.substring(11, 16)}`}</h3>
        {logsOfTheHour.logs.map((r, i) => renderResultCard(r, i))}
      </div>
    );
  }

  function loadMore() {
    loadData(state.page + 1).then();
  }

  return (
    <>
      {sortedLogs.map((r, i) => renderHours(r, i))}
      <Button
        variant="contained"
        color="primary"
        fullWidth
        onClick={loadMore}
        disabled={state.page === -1}
      >
        load more
      </Button>
    </>
  );
};

function renderResultCard(result, index) {
  return (
    <Card key={result.sourceRoot + index} style={{ marginBottom: 10 }}>
      <CardHeader subheader={result.sourceRoot} />
      {renderRootResultMessages(result)}

      {(result.fileResults || []).map((f, idx) => (
        <StyledCardContent isEven={idx % 2 === 0} key={f.file}>
          <Typography
            variant="body1"
            color="textPrimary"
            component="p"
            style={{ overflowWrap: "break-word" }}
          >
            {f.file}
          </Typography>
          <br />
          <Grid container direction="column" justifyContent="center" spacing={1}>
            {(f.messages || []).map((m, i) => (
              <Grid key={(m.message || "") + i} size={12}>
                <Alert severity={m.level} fullWidth>
                  {m.message}
                </Alert>
              </Grid>
            ))}
          </Grid>
        </StyledCardContent>
      ))}
    </Card>
  );
}

function renderRootResultMessages(result) {
  if (!result.messages || result.messages.length === 0) return null;

  return (
    <StyledCardContent isEven={false}>
      <Grid container direction="column" justifyContent="center" spacing={1}>
        {(result.messages || []).map((m, i) => (
          <Grid key={(m.message || "") + i} size={12}>
            <Alert severity={m.level} fullWidth>
              {m.message}
            </Alert>
          </Grid>
        ))}
      </Grid>
    </StyledCardContent>
  );
}
